'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CartLocationDetail = require('./CartLocationDetail');

var _CartLocationDetail2 = _interopRequireDefault(_CartLocationDetail);

var _CartPaymentScreen = require('./CartPaymentScreen');

var _CartPaymentScreen2 = _interopRequireDefault(_CartPaymentScreen);

var _MainStore = require('../../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _ScheduleScreenStore = require('../../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _CartLoginSection = require('./CartLoginSection');

var _CartLoginSection2 = _interopRequireDefault(_CartLoginSection);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Utility = require('../../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _ScheduleOrderModal = require('../../schedule/ScheduleOrderModal');

var _ScheduleOrderModal2 = _interopRequireDefault(_ScheduleOrderModal);

var _Constants = require('../../Constants');

var Constants = _interopRequireWildcard(_Constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CartLeftStructure = function (_React$Component) {
    _inherits(CartLeftStructure, _React$Component);

    function CartLeftStructure(props) {
        _classCallCheck(this, CartLeftStructure);

        var _this = _possibleConstructorReturn(this, (CartLeftStructure.__proto__ || Object.getPrototypeOf(CartLeftStructure)).call(this, props));

        _this.state = {
            activeLocation: "",
            loadScheduleScreen: false,
            loggedInUserObj: {}
        };

        _this._bind('handleScheduleScreenModal', 'handleUserState');
        return _this;
    }

    _createClass(CartLeftStructure, [{
        key: '_bind',
        value: function _bind() {
            var _this2 = this;

            for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
                methods[_key] = arguments[_key];
            }

            methods.forEach(function (method) {
                return _this2[method] = _this2[method].bind(_this2);
            });
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {

            var activeLocation = _MainStore2.default.getActiveLocation();

            this.setState({
                activeLocation: activeLocation
            });

            var currentUser = _parse2.default.User.current();

            if (!Utils.isEmptyObj(currentUser)) {
                // refresh the current parse user data
                Utils.refreshCurrentParseUser();
                this.setState({
                    loggedInUserObj: {
                        isLoggedInExistingUser: true,
                        savedCards: true,
                        addCards: false,
                        guestUser: false
                    }
                });
            } else {
                this.setState({
                    loggedInUserObj: {
                        isLoggedInExistingUser: false,
                        savedCards: false,
                        addCards: true,
                        guestUser: true
                    }
                });
            }
        }

        //load scheduleScreenView

    }, {
        key: 'handleScheduleScreenModal',
        value: function handleScheduleScreenModal(status) {
            this.setState({
                loadScheduleScreen: status
            });
        }
    }, {
        key: 'loadScheduleScreenView',
        value: function loadScheduleScreenView() {
            var loadScheduleScreen = this.state.loadScheduleScreen;
            var _props = this.props,
                history = _props.history,
                locId = _props.locId;

            //show schedule modal

            if (loadScheduleScreen) {
                return _react2.default.createElement(_ScheduleOrderModal2.default, {
                    callBackParent: this.handleScheduleScreenModal,
                    history: history,
                    locId: locId
                });
            } else {
                return null;
            }
        }
    }, {
        key: 'logInSection',
        value: function logInSection() {

            if (!this.state.loggedInUserObj.isLoggedInExistingUser) {
                return _react2.default.createElement(_CartLoginSection2.default, {
                    callbackParent: this.handleUserState,
                    history: this.props.history,
                    locId: this.props.locId
                });
            } else {
                return null;
            }
        }
    }, {
        key: 'handleUserState',
        value: function handleUserState(isLoggedInExistingUser) {

            var self = this;

            self.setState({
                loggedInUserObj: {
                    isLoggedInExistingUser: isLoggedInExistingUser,
                    guestUser: !isLoggedInExistingUser,
                    savedCards: true,
                    addCards: false
                }
            }, function () {
                self.props.handleUserLogin(self.state.loggedInUserObj.isLoggedInExistingUser);
            });
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                { id: 'cart-right', className: 'col-md-7 mt-4 mb-4' },
                _react2.default.createElement(
                    'div',
                    { className: 'offer-dedicated-body-left' },
                    this.loadScheduleScreenView(),
                    _react2.default.createElement(_CartLocationDetail2.default, {
                        location: this.state.activeLocation,
                        callBackParent: this.handleScheduleScreenModal,
                        history: this.props.history,
                        locId: this.props.locId
                    }),
                    _react2.default.createElement('div', { className: 'pt-2' }),
                    this.logInSection(),
                    _react2.default.createElement(_CartPaymentScreen2.default
                    // loadScheduleScreen = {this.state.loadScheduleScreen}
                    , { isMobile: this.props.isMobile,
                        loggedInUserObj: this.state.loggedInUserObj,
                        callBackParent: this.handleScheduleScreenModal
                    })
                )
            );
        }
    }]);

    return CartLeftStructure;
}(_react2.default.Component);

exports.default = CartLeftStructure;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-left/CartLeftStructure.jsx
// module id = 566
// module chunks = 0